<!--
Map builder route admin screen.
@author crm4f
-->

<template>
  
  <div class="routeAdminContainer">
    <div class="routeOptionsContainer">

      <h1 class="headerDivider">Routes</h1>
      <hr style="margin-top:2px !important">

      <div class="btn-group" role="group" aria-label="newItemOptions">
        <button type="button" :disabled="currentRoute == null || currentRoute?.routeType == null || currentRoute?.routeName == null" class="btn btn-primary active btn-sm" @click="saveCurrentRoute()">Save</button>
        <button type="button" :disabled="currentRoute == null" class="btn btn-primary active btn-sm" @click="clearCurrentRoute()">Cancel</button>
        <button type="button" :disabled="currentRoute == null" class="btn btn-primary active btn-sm" @click="deleteCurrentRoute()">Delete</button>
      </div>

      <!-- NEW ROUTE -->
      <div class="optionRow">
        <div style="width: fit-content; justify-content: center; display: flex;">
          <button 
            style="width:auto !important" 
            class="btn btn-primary active btn-sm" 
            @click="createNewRoute()">
            New Route
          </button>

          <select
            :disabled="currentRoute?.newish" 
            :class="{'inputDisabled' : currentRoute?.newish}" 
            @change="routeTypeChanged()"
            class="form-control-sm" 
            v-model="currentRouteType">
            <option v-for="(routeType ,i) in routeTypes" :value="routeType" :key="i">{{ routeType }}</option>
          </select>
        </div>

        <select 
          :disabled="currentRoute?.newish" 
          :class="{'inputDisabled' : currentRoute?.newish}"
          @change="routeChanged()"
          class="form-control-sm" 
          v-model="currentRoute">
          <option v-for="(route,i) in routes" :value="route" :key="i">{{ route.routeName }}</option>
        </select>
        <br>
      </div>

      <div v-if="currentRoute !== null">

        <!-- ROUTE ID -->
        <div class="optionRow">
          <div>
            <label for="id">Id:</label>
          </div>
          <input 
            id="id"
            :disabled="true" 
            :class="{'inputDisabled' : true}" 
            class="form-control-sm" 
            v-model="currentRoute.routeId"
            label="id"
          />
          <br>
        </div>

        <!-- ROUTE NAME -->
        <div class="optionRow">
          <div>
            <label for="name">Route:</label>
          </div>
          <input 
            label="name"
            id="name"
            :disabled="currentRoute == null"
            :class="{'inputDisabled' :currentRoute == null}"
            class="form-control-sm"
            v-model="currentRoute.routeName"
            required
          />
          <br>
        </div>

        <!-- TYPE -->
        <div class="optionRow">
          <div>
            <label for="type">Type:</label>
          </div>
          <select  
            v-model="currentRoute.routeType"
            label="type"
            id="type"
            :disabled="currentRoute == null" 
            :class="{'inputDisabled' :currentRoute == null}" 
            class="form-control-sm" >
            <option v-for="(routeType ,i) in routeTypes" 
              :value="routeType"
              :key="i"
            >
              {{ routeType }}
            </option>
          </select>
          <br>
        </div>

        <!-- LEGS -->
        <div class="optionRow">
          <div>
            <label for="legs">Legs:</label>
          </div>
          
          <div>
            <div>
              <ul class="list-group">
                <li class="list-group-item" v-bind:key="index" v-for="leg, index in routeLegs">
                  {{ leg.leg.nodeFrom.nodeName + ' to ' + leg.leg.nodeTo.nodeName }}
                </li>
              </ul>
            </div>

            <div class="d-inline-flex align-items-center justify-content-around">
              <button 
                :disabled="currentLeg == null" 
                class="btn btn-primary active btn-sm" 
                @click="addSelectedLeg()">
                Add selected leg
              </button>
              <button 
                :disabled="routeLegs == null" 
                class="btn btn-primary active btn-sm" 
                @click="removeLastLeg()">
                Remove last leg
              </button>
            </div>
          </div>
        </div>
      </div>

    
      
      <h1 class="headerDivider">Legs</h1>
      <hr style="margin-top:2px !important">

      <div class="btn-group" role="group" aria-label="newItemOptions">
        <button type="button" :disabled="currentLeg == null || currentLeg?.nodeFrom == null || currentLeg?.nodeTo == null" class="btn btn-primary active btn-sm" @click="saveCurrentLeg()">Save</button>
        <button type="button" :disabled="currentLeg == null" class="btn btn-primary active btn-sm" @click="clearCurrentLeg()">Cancel</button>
        <button type="button" :disabled="currentLeg == null" class="btn btn-primary active btn-sm" @click="deleteCurrentLeg()">Delete</button>
      </div>

      <div class="optionRow">
        <button style="width:auto !important" class="btn btn-primary active btn-sm" @click="createNewLeg()">New leg</button>
        <select class="form-control-sm" v-model="currentLeg" @change="legChanged()">
          <template v-for="(leg,i) in legs" :key="i">
            <option
              :value="leg">
              {{ (leg?.nodeFrom?.nodeName == null ? '___' : leg.nodeFrom.nodeName) + ' to ' + (leg?.nodeTo?.nodeName == null ? '___' : leg.nodeTo.nodeName) }}
            </option>
          </template>
        </select>
        <br>
      </div>

      <div v-if="currentLeg !== null">
        <!-- LEG ID -->
        <div class="optionRow">
          <div>
            <label for="legId">Id:</label>
          </div>
          <input 
            id="legId"
            :disabled="true"
            :class="{'inputDisabled' :currentLeg == null}"
            class="form-control-sm"
            v-model="currentLeg.legId"
            label="legId"
          />
          <br>
        </div>

        <!-- NODE FROM -->
        <div class="optionRow">
          <div>
            <label for="nodeFrom">Node from:</label>
          </div>
          <select 
          @change="legChanged();"
          id="nodeFrom"
          label="nodeFrom"
          :disabled="currentLeg == null" 
          :class="{'inputDisabled' :currentLeg == null}" 
          class="form-control-sm" 
          v-model="currentLeg.nodeFrom"
          >
            <template v-for="(node,i) in nodes" :key="i">
              <option  
                v-if="node !== null"
                :value="node" 
              >
                {{ node?.nodeName }}
              </option>
            </template>
          </select>
          <br>
        </div>

        <!-- NODE TO -->
        <div class="optionRow">
          <div>
            <label for="nodeTo">Node to:</label>
          </div>
          <select 
          @change="legChanged();"
          v-model="currentLeg.nodeTo"
          id="nodeTo"
          label="nodeTo"
          :disabled="currentLeg == null" 
          :class="{'inputDisabled' :currentLeg == null}" 
          class="form-control-sm">
            <template v-for="(node,i) in nodes" :key="i">
              <option  
                v-if="node !== null"
                :value="node" 
              >
                {{ node?.nodeName }}
              </option>
            </template>
          </select>
          <br>
        </div>
      </div>

      <h1 class="headerDivider">Nodes</h1>
      <hr style="margin-top:2px !important">

      <div class="btn-group" role="group" aria-label="newItemOptions">
        <button type="button" :disabled="currentNode == null || currentNode.nodeName == null" class="btn btn-primary active btn-sm" @click="saveCurrentNode()">Save</button>
        <button type="button" :disabled="currentNode == null" class="btn btn-primary active btn-sm" @click="clearCurrentNode()">Cancel</button>
        <button type="button" :disabled="currentNode == null" class="btn btn-primary active btn-sm" @click="deleteCurrentNode()">Delete</button>
      </div>

      <div class="optionRow">
        <button style="width:auto !important" class="btn btn-primary active btn-sm" @click="createNewNode()">New Node</button>
        <select class="form-control-sm" v-model="currentNode" @change="nodeChanged()" :disabled="nodes == null || currentNode?.newish" :class="{'inputDisabled' :nodes == null || currentNode?.newish}">
          <template v-for="(node,i) in nodes" :key="i">
            <option
              :value="node">
              {{ node.nodeName }}
            </option>
          </template>
        </select>
        <br>
      </div>

      <div v-if="currentNode !== null">
        <!-- NODE ID -->
        <div class="optionRow">
          <div>
            <label for="nodeId">Id:</label>
          </div>
          <input 
            id="nodeId"
            label="nodeId"
            :disabled="true"
            :class="{'inputDisabled' :currentNode == null}"
            class="form-control-sm"
            v-model="currentNode.nodeId"
          />
          <br>
        </div>

        <!-- NODE NAME -->
        <div class="optionRow">
          <div>
            <label for="nodeName">Name:</label>
          </div>
          <input 
            id="nodeName"
            label="nodeName"
            :disabled="currentNode == null"
            :class="{'inputDisabled' :currentNode == null}"
            class="form-control-sm"
            v-model="currentNode.nodeName"
          />
          <br>
        </div>
      </div>

    </div>

    <div class="gmapContainer">
      <GMapMap
      :center='DEFAULT_CAMPUS_LATLNG'
      :zoom='17'
      class='mapCanvas tallMap'
      id="campusMap"
      ref='mapRef'
      style="width: 100%; height: 100vh"
      :options='{
        styles: getStyles(),
        fullscreenControl: false,
        mapTypeControl: false,
        mapTypeControlOptions: {
          position: google && google.maps.ControlPosition.TOP_LEFT,
          style: google && google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        streetViewControl: true,
        zoomControl: true
      }'>

        <!-- NODE MARKERS -->
        <GMapMarker v-bind:key="index" v-for="node, index in nodes"
          ref="nodeMarker"
          :position="{lat: Number(node.lat), lng: Number(node.lng)}"
          :clickable="true"
          :draggable="false"
          :icon="{
            url: require('@/assets/blue-dot.png'),
            scaledSize: {width: 13, height: 13},
          }"
          @click="openInfoWindow(node.nodeId)"
        >
          <GMapInfoWindow @closeclick="openInfoWindow(null)" :closeclick="true" :opened="node.nodeId == openedInfoWindow">
            <div>
              {{ node.nodeName }}
            </div>
          </GMapInfoWindow>
        </GMapMarker> 

        <!-- POLYLINES FOR SELECTED ROUTE -->
        <GMapPolyline v-bind:key="index" v-for="leg, index in routeLegs"
        :path="[{ lat: Number(leg.leg.nodeFrom.lat), lng: Number(leg.leg.nodeFrom.lng) }, { lat: Number(leg.leg.nodeTo.lat), lng: Number(leg.leg.nodeTo.lng) }]"
        :editable="false"
        :options="{
          strokeColor: '#d62929',
          strokeWeight: 7
        }"
        ref='routePolyline'
        />

        <!-- POLYLINE FOR SELECTED LEG-->
        <GMapPolyline v-if="currentLeg !== null && (currentLeg.nodeFrom != null && currentLeg.nodeTo != null)"
        :path="[{ lat: Number(currentLeg.nodeFrom.lat), lng: Number(currentLeg.nodeFrom.lng) }, { lat: Number(currentLeg.nodeTo.lat), lng: Number(currentLeg.nodeTo.lng) }]"
        :editable="false"
        :options="{
          strokeColor: '#29D6D6',
          strokeWeight: 7
        }"
        ref="legPolyline"
        />

        <!-- NODE MARKER -->
        <GMapMarker v-if="currentNode != null"
          ref="nodeMarker"
          :key="index"
          :position="{lat: Number(currentNode.lat), lng: Number(currentNode.lng)}"
          :clickable="true"
          :draggable="true"
          @dragend="updateNodePos($event);"
        />
      </GMapMap>
    </div>

  </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'

const DEFAULT_CAMPUS_LATLNG = {lat: 55.872336, lng: -4.288118}

const buildings = ref(null)
const routeTypes = ref(null)
const currentRouteType = ref(null)
const currentRoute = ref(null)
const currentLeg = ref(null)
const currentNode = ref(null)
const routes = ref(null)
const legs = ref(null)
const routeLegs = ref(null)
const nodes = ref(null)
const entrances = ref(null)
const nodeMarker = ref(null)
const openedInfoWindow = ref(null)

const mapRef = ref(null)
const map = ref(null)
const google = ref(null)

onMounted(() => {

  getLegs()
  getNodes()
  getRouteTypes()
  getBuildings()
  getEntrances()

  mapRef.value.$gmapApiPromiseLazy().then((gmapApi) => {
    console.log('gmapApi promise fulfilled')
    google.value = gmapApi
  }).then(() => {
    mapRef.value.$mapPromise.then((mapResponse) => {
    // Wait for Google Maps to load
      map.value = mapResponse
    })
  })
})

function updateNodePos(event) {
  // update currentNode position
  currentNode.value.lat = Number(event.latLng.lat())
  currentNode.value.lng = Number(event.latLng.lng())

  // Is there a rendered leg? If so, update it if it concerns this node
  if (currentLeg.value !== null && currentLeg.value.nodeFrom !== null && currentLeg.value.nodeTo !== null) {
    if (currentLeg.value.nodeFrom.nodeId == currentNode.value.nodeId) {
    currentLeg.value.nodeFrom.lat = currentNode.value.lat
    currentLeg.value.nodeFrom.lng = currentNode.value.lng
    } else if (currentLeg.value.nodeTo.nodeId == currentNode.value.nodeId) {
      currentLeg.value.nodeTo.lat = currentNode.value.lat
      currentLeg.value.nodeTo.lng = currentNode.value.lng
    }
  }

  // Is there a rendered route? If so, update it if it concerns this node
  if (routeLegs.value !== null) {
    let updatedLegs = routeLegs.value.filter(leg => (leg.leg.nodeFrom.nodeId == currentNode.value.nodeId) || (leg.leg.nodeTo.nodeId == currentNode.value.nodeId))
    for (let leg of updatedLegs) {
      if (leg.leg.nodeFrom.nodeId == currentNode.value.nodeId) {
        leg.leg.nodeFrom.lat = currentNode.value.lat
        leg.leg.nodeFrom.lng = currentNode.value.lng
      } else {
        leg.leg.nodeTo.lat = currentNode.value.lat
        leg.leg.nodeTo.lng = currentNode.value.lng
      }
    }
  }


  // Update the value in the nodes array, so that it re-renders as expected
  const updatedNode = nodes.value.find((node) => node.nodeId == currentNode.value.nodeId )
  updatedNode.lat = currentNode.value.lat.toString()
  updatedNode.lng = currentNode.value.lng.toString()
}


/**
  * Route Type change handler.
  * Fetches all routes for the selected type. 
*/
function routeTypeChanged () {
  currentRoute.value = null
  routeLegs.value = null
  getRoutes()
}

/**
  * Route change handler.
*/
function routeChanged () {
  if (currentRoute.value != null && currentRoute.value?.routeId != 0) {
    axios.get("map/admin/routes/" + currentRoute.value.routeId + "/legs")
    .then((response) => {
      routeLegs.value = response.data
      map.value.panTo(new google.value.maps.LatLng(routeLegs.value[0].leg.nodeFrom.lat, routeLegs.value[0].leg.nodeTo.lng))
    })
  }
}

/**
   * Method to open/track info windows for the node markers.
*/
function openInfoWindow (nodeId) { 
  openedInfoWindow.value = nodeId
}

/**
   * Leg change handler.
*/
function legChanged () {
  if (currentLeg.value != null && currentLeg.value.nodeFrom != null && currentLeg.value.nodeTo != null) {
    map.value.panTo(new google.value.maps.LatLng(currentLeg.value.nodeFrom.lat, currentLeg.value.nodeTo.lng))
  }
}

/**
  * Node change handler.
*/
function nodeChanged () {
  if (currentNode.value !== null) {
    map.value.panTo({lat: Number(currentNode.value.lat), lng: Number(currentNode.value.lng)})
  }
}

function createNewRoute () {
  axios.post("map/admin/routes")
    .then((response) => {
      currentRoute.value = response.data
      routeLegs.value = []
      currentRoute.value.newish = true
      currentRoute.value.routeType = currentRouteType.value
      if(routes.value != null) {
        routes.value.unshift(currentRoute.value)
      }
      routeChanged()
    })
}

function saveCurrentRoute () {
  var routeWrapper = {
    route: currentRoute.value,
    routeLegs: routeLegs.value
  }
  console.log(routeWrapper)
  axios.put("map/admin/routes", routeWrapper)
    .then((response) => {
      if (response.status == 200) {
        alert('Update successful.')
      } else if (response.status == 401 || response.status == 403) {
        alert('You are not authenticated. Check console for details.')
      } else {
        alert('Something unexpected happened. Check console for details')
      }
      if(routes.value != null) {
        var index = routes.value.indexOf(currentRoute.value)
        routes.value[index] = response.data
      }
      currentRoute.value = response.data
      currentRoute.value.newish = false       
    })
}

function clearCurrentRoute () {
  routeLegs.value = null
  if (confirm('Cancel current route edit?')) {
    currentRoute.value = null
  }
  routeChanged()
}

function deleteCurrentRoute () {
  if(confirm("Are you sure?")) {
    axios.delete("map/admin/routes/" + currentRoute.value.routeId)
    .then((response) => {
      if (response.status == 200) {
        alert('Deleted successfully.')
      } else if (response.status == 401 || response.status == 403) {
        alert('You are not authenticated. Check console for details.')
      } else {
        alert('Something unexpected happened. Check console for details')
      }
      currentRoute.value = null
      routeLegs.value = null
      routeChanged()
      getRoutes()
    })  
  }
}
  
/**
  * Create a new, blank, unsaved leg in memory and trigger a leg change event.
*/
function createNewLeg () {
  axios.post("map/admin/legs")
  .then((response) => {
    currentLeg.value = response.data
    currentLeg.value.newish = true
    if (legs.value !== null) {
      legs.value.unshift(currentLeg.value)
    }
    legChanged()
  })  
}
  
/**
 * Update the leg in the database.
 * todo refresh object to get the new id on first save
 */
function saveCurrentLeg() {
  if (currentLeg.value.nodeFrom.nodeId === currentLeg.value.nodeTo.nodeId) {
    alert("Node From and Node To cannot be the same location.")
  } else {
    axios.put("map/admin/legs", currentLeg.value)
    .then((response) => {
      if (response.status == 200) {
        alert('Update successful.')
      } else if (response.status == 401 || response.status == 403) {
        alert('You are not authenticated. Check console for details.')
      } else {
        alert('Something unexpected happened. Check console for details')
      }
      if(legs.value != null) {
        var index = legs.value.indexOf(currentLeg.value)
        legs.value[index] = response.data
      }
      currentLeg.value = response.data
      currentLeg.value.newish = false     
    })
  }
}

/**
  * Cancel changes and trigger a leg change event.
*/
function clearCurrentLeg () {
  if(confirm("Are you sure?")) {
    currentLeg.value = null
    legChanged()
    getLegs()
  }             
}

/**
 * Delete the leg from the database and trigger a leg change event.
 */
function deleteCurrentLeg () {
  if(confirm("Are you sure?")) {
    axios.delete("map/admin/legs/" + currentLeg.value.legId)
    .then((response) => {
      if (response.status == 200) {
        alert('Deleted successfully.')
      } else if (response.status == 401 || response.status == 403) {
        alert('You are not authenticated. Check console for details.')
      } else {
        alert('Something unexpected happened. Check console for details')
      }
      currentLeg.value = null
      legChanged()
      getLegs()
    })  
  }      
}

/**
  * Create a new, blank, unsaved node in memory and trigger a node change event.
*/
function createNewNode () {
  axios.post("map/admin/nodes")
  .then((response) => {
    currentNode.value = response.data
    currentNode.value.newish = true
    currentNode.value.lat = DEFAULT_CAMPUS_LATLNG.lat
    currentNode.value.lng = DEFAULT_CAMPUS_LATLNG.lng
    if(nodes.value != null) {
      nodes.value.unshift(currentNode.value)  
    }
    nodeChanged()
  })
}

/**
  * Update the node in the database.
  * todo refresh object to get the new id on first save
*/
function saveCurrentNode () {
  axios.put("map/admin/nodes", currentNode.value)
  .then((response) => {
    if (response.status == 200) {
      alert('Update successful.')
    } else if (response.status == 401 || response.status == 403) {
      alert('You are not authenticated. Check console for details.')
    } else {
      alert('Something unexpected happened. Check console for details')
    }
    if(nodes.value != null) {
      var index = nodes.value.indexOf(currentNode.value)
      nodes.value[index] = response.data
    }
    currentNode.value = response.data
    currentNode.value.newish = false        
  })   
}

/**
  * Cancel changes and trigger a node change event.
*/
function clearCurrentNode () {
  if(confirm("Are you sure?")) {
    currentNode.value = null
    nodeChanged()
    getNodes()
  }
}

/**
  * Delete the node from the database and trigger a node change event.
*/
function deleteCurrentNode () {
  if(confirm("Are you sure?")) {
    axios.delete("map/admin/nodes/" + currentNode.value.nodeId)
    .then((response) => {
      if (response.status == 200) {
        alert('Deleted successfully.')
      } else if (response.status == 401 || response.status == 403) {
        alert('You are not authenticated. Check console for details.')
      } else {
        alert('Something unexpected happened. Check console for details')
      }
      currentNode.value = null
      nodeChanged()
      getNodes()
    })
  }      
}

function getBuildings () {
  axios.get('map/admin/buildings',{withCredentials:false})
  .then(response => {
    buildings.value = response.data
  })
}

function getLegs () {
  axios.get('map/admin/legs',{withCredentials:false})
  .then(response => {
    legs.value = response.data
  })
}

function getRouteTypes () { 
  axios.get('map/admin/routes/types', {withCredentials:false})
  .then(response => {
    routeTypes.value = response.data
  })
}

function getNodes() {
  axios.get('map/admin/nodes', {withCredentials:false})
  .then(response => {
    nodes.value = response.data
  })
}

/**
  * Get all routes
*/
function getRoutes () {
  var params = ""
  if (currentRouteType.value != null) {
    params =  "?routeType=" + currentRouteType.value
  }
  axios.get("map/admin/routes" + params)
  .then((response) => {
      routes.value = response.data
    }
  );   
}

function getEntrances () {
  axios.get('map/admin/features/entrances', {withCredentials:false})
  .then(response => {
      entrances.value = response.data
  })
}

function addSelectedLeg () {
  if (isLegValid(currentLeg.value)) {
    let routeLeg = {id: {routeId: currentRoute.value.routeId, legId: currentLeg.value.legId}}
    routeLeg.leg = currentLeg.value
    if (routeLegs.value == null) {
      routeLegs.value = []
    }
    routeLeg.orderNum = routeLegs.value.length + 1
    routeLegs.value.push(routeLeg)
  } else {
    alert("The selected leg must join the previous leg.")
  }    
}

function removeLastLeg () {
  routeLegs.value.pop()
}

/**
  * return true if the leg can be joined to the current route. 
  * When leg is the first node, always allow.
  * When leg is the second node, allow if it attaches to either end of the first node.
  * When leg is a subsequent node, allow if it attaches to the open end of the last node.
*/
function isLegValid (leg) {
  var valid = false
  if (routeLegs.value == null || routeLegs.value.length == 0) {
    valid = true     
  } else {
    var lastLeg = routeLegs.value[routeLegs.value.length - 1].leg
    if (leg.legId != lastLeg.legId) {
      if (routeLegs.value.length == 1) {          
        valid = lastLeg.nodeTo.nodeId == leg.nodeFrom.nodeId ||
            lastLeg.nodeTo.nodeId === leg.nodeTo.nodeId ||
            lastLeg.nodeFrom.nodeId == leg.nodeFrom.nodeId ||
            lastLeg.nodeFrom.nodeId == leg.nodeTo.nodeId
      } else {
        // Get the last open node in the route.
        var penLeg = routeLegs.value[routeLegs.value.length - 2].leg
        var lastNode = lastLeg.nodeTo
        if (penLeg.nodeFrom.nodeId == lastNode.nodeId || penLeg.nodeTo.nodeId == lastNode.nodeId) {
          lastNode = lastLeg.nodeFrom
        }
        valid = lastNode.nodeId == leg.nodeFrom.nodeId || lastNode.nodeId == leg.nodeTo.nodeId
      }
    }
  } 
  return valid
}

/**
* Styles config for the Gmap plugin. 
*/
function getStyles () {
  return [
    { featureType: 'road', elementType: 'geometry', stylers: [ { lightness: 100 }, { visibility: 'simplified' } ] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [ { color: '#575656' } ] },
    { featureType: 'road', elementType: 'labels.text.stroke', stylers: [ { color: '#FFFFFF' } ] },
    { featureType: 'poi', elementType: 'labels', stylers: [ { visibility: 'off' } ] } 
  ]
}

</script>
  
<style scoped>

.routeAdminContainer {
  display: flex;
}

.gmapContainer {
  width: 100%;
  padding: 10px;
  height: fit-content;
}

.listHeader {
  color: #003865;
  font-weight: bold;
}

.hrhalfheight {
  width: 75%;
  margin: auto;
}

.feature-list {
  margin-bottom: 15px;
}

.inputDisabled {
  cursor: not-allowed;
}

.showFeatures, .showFeatures button {
  width: 100%;
}

.featuresContainer {
  margin-top: 15px;
}

.routeOptionsContainer {
  padding: 0px 0px 10px 10px;
  width: 60%;
}

.headerDivider {
  margin-top: 15px;
  margin-bottom: 0px;
  text-align: left;
  font-weight: bold;
  color: #003865;
}

.optionRow {
  display: flex;
  margin: 10px 0px 0px 5px;
  align-items: center;
  justify-content: space-between;
}

.optionRow > :nth-child(1) {
  margin-right: 15px;
  width: 25%;
  text-align: left;
  word-break: break-word;
  font-size: 13px;
  font-weight: bold;
}

.optionRow > :nth-child(2) {
  flex: 1;
  width: 100% !important;
}

</style>